import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]
  
  connect() {
    this.shown = false

    // Bind event handlers
    this.handleKeydown = this.handleKeydown.bind(this)
    this.handleOpen = this.handleOpen.bind(this)

    // Add event listeners
    document.addEventListener('keydown', this.handleKeydown)
    window.addEventListener('floating-search:open', this.handleOpen)
  }
  
  disconnect() {
    // Clean up event listeners
    document.removeEventListener('keydown', this.handleKeydown)
    window.removeEventListener('floating-search:open', this.handleOpen)
  }
  
  show() {
    this.element.setAttribute("data-active", "true");
    if (this.hasContentTarget) {
      this.contentTarget.setAttribute("data-active", "true");
    }
    this.shown = true;
  }
  
  hide() {
    this.element.setAttribute("data-active", "false");
    if (this.hasContentTarget) {
      this.contentTarget.setAttribute("data-active", "false");
    }
    this.shown = false;
  }
  
  dismiss() {
    this.hide()
  }
  
  handleKeydown(event) {
    // Hide on Escape key
    if (event.key === 'Escape' && this.shown) {
      this.hide()
    }

    // Show on Cmd+K (Mac) or Ctrl+K (others)
    if ((event.metaKey || event.ctrlKey) && (event.key === 'k' || event.key === 'K')) {
      const target = event.target
      const isEditable = target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable)
      const insideFloating = this.element.contains(target)
      // Ignore shortcut only if user is typing in another editable element outside the floating search
      if (isEditable && !insideFloating) return
      event.preventDefault()
      event.stopPropagation()
      if (this.shown) {
        // Toggle off (hide) when already visible
        this.hide()
      } else {
        // Show and focus when not visible
        this.show()
        requestAnimationFrame(() => this.focusInput())
      }
    }
  }

  handleOpen() {
    this.show()
    requestAnimationFrame(() => this.focusInput())
  }

  focusInput() {
    const input = this.element.querySelector('[data-search-form-target="input"]')
    if (input) {
      input.focus()
      // Move cursor to end
      const val = input.value
      input.value = ''
      input.value = val
    }
  }
}
